module.exports = __webpack_public_path__ + "img/goldenbravoo.9d18bbc5.png";